// extracted by mini-css-extract-plugin
export var equalColumn = "_hk-0";